module.exports = __webpack_public_path__ + "13bc4ba753ace47055db207a624f914b.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1152
// module chunks = 0